import { render, staticRenderFns } from "./PoliciesAll.vue?vue&type=template&id=dce21ad0"
import script from "./PoliciesAll.vue?vue&type=script&lang=js"
export * from "./PoliciesAll.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports